import axios from "axios";

import { GET_ERRORS, TOKEN_ADD } from "./types";
import { db } from "../firebase";
import { collection, setDoc, doc } from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

export const addToken = (param, history) => async (dispatch) => {
  var TokenData = new FormData();

  TokenData.append("name", param.name);
  TokenData.append("symbol", param.symbol);
  TokenData.append("address", param.addresses);
  TokenData.append("chainId", 10);
  TokenData.append("decimal", 18);
  TokenData.append("file", param.file);

  const storage = getStorage();
  const storageRef = ref(storage, `images/${param.file.name}`);
  // 'file' comes from the Blob or File API
  const file = param.file;
  const uploadTask = uploadBytesResumable(storageRef, file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log("Upload is " + progress + "% done");
    },
    (error) => {
      // Handle unsuccessful uploads
      dispatch({
        type: GET_ERRORS,
        payload: error,
      });
    },
    () => {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
        const tokenRef = doc(collection(db, "tokens"));
        const docRef = await setDoc(tokenRef, {
          id: tokenRef.id,
          name: param.name,
          symbol: param.symbol,
          address: param.addresses,
          chainId: 10,
          decimal: 18,
          file: downloadURL,
        });
        dispatch({
          type: TOKEN_ADD,
          payload: tokenRef,
        });
      });
    }
  );
};

// export const updateToken = (param) => dispatch => {
//     console.log("updateToken>>>>>",param);
//     // return false;
//     var tokenUpdateData = new FormData();

//     if (!isEmpty(param.name))   tokenUpdateData.append('name',param.name );
//     if (!isEmpty(param.symbol)) tokenUpdateData.append('symbol',param.symbol );
//     if (!isEmpty(param.addresses)) tokenUpdateData.append('addresses',param.addresses );
//     if (!isEmpty(param.chainId))tokenUpdateData.append('chainId',10 );
//     if (!isEmpty(param.decimals)) tokenUpdateData.append('decimals',18 );
//     if (!isEmpty(param.file)) {
//         tokenUpdateData.append('file',param.file );
//         console.log('1111111');
//     }
//     else {
//         console.log('222222222');
//     }
//     console.log("tokenUpdateData>>>>>",tokenUpdateData)
//     axios
//         .post("/api/token-update", tokenUpdateData)
//         .then(res =>
//             dispatch({
//                 type: TOKEN_UPDATE,
//                 payload: res,
//             })
//         ).catch(err =>
//         dispatch({
//             type: GET_ERRORS,
//             payload: err.response.data
//         })
//     );
// };
